import { createRouter, createWebHistory } from "vue-router";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "@/stores/storeRequests";
import TheHomePage from "@/pages/TheHomePage.vue";
import TheNotFindPage from "@/pages/TheNotFindPage.vue";

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			name: "home",
			component: TheHomePage,
		},
		{
			path: "/:pathMatch(.*)*",
			name: "404",
			component: TheNotFindPage,
		},
	],
	scrollBehavior(to, from, savedPosition) {
		const storeScroll = useScrollStore();
		const headerOffset = storeScroll.header?.offsetHeight || 100;

		if (to.hash) {
			return {
				el: to.hash,
				behavior: "smooth",
				top: headerOffset,
			};
		}

		if (savedPosition) {
			return savedPosition;
		}
		return { top: 0 };
	},
});

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const storeRequests = useRequestsStore();
	const { verification_token } = to.query	
	if (verification_token) {
		storeRequests.verification(verification_token);
		router.replace({ path: to.path, query: {} });
	};
    if (requiresAuth && !storeRequests.isAuthenticated) {
      	next('/');
		
    } else {
      	next();
    }
});

export default router;
